/**
 * SF-5080: which list the page shows. Voters only get lists open for voting (sf-api filters
 * them); managers and insights users get every list, tagged when it is not open or archived.
 */
import { Select, Space, Tag, Typography } from 'antd';
import { type PriorityList } from '../api/prioritiesClient';
import { LIST_STATUS_LABELS } from '../constants';

interface Props {
  lists: PriorityList[];
  value: string;
  loading: boolean;
  onChange: (listId: string) => void;
}

export const ListPicker: React.FC<Props> = ({ lists, value, loading, onChange }) => {
  const known = lists.some((l) => l.id === value);
  // Before the lists load (or if they fail) the chosen list is the only option, so the select
  // never shows a bare id. Once they load, the options are always the lists the person can use:
  // a chosen list that is not among them (hidden, gone) leaves the select empty, never the
  // only choice.
  const options = lists.length > 0 ? lists : [{ id: value, name: 'This list', status: null }];
  return (
    <Space style={{ marginBottom: 8 }}>
      <Typography.Text strong>List</Typography.Text>
      <Select
        aria-label="List"
        style={{ minWidth: 260 }}
        loading={loading}
        value={known || lists.length === 0 ? value : undefined}
        placeholder="Pick a list"
        onChange={onChange}
        options={options.map((l) => ({
          value: l.id,
          title: l.name,
          label: (
            <Space size={4}>
              {l.name}
              {l.status && l.status !== 'voting' && <Tag>{LIST_STATUS_LABELS[l.status]}</Tag>}
            </Space>
          ),
        }))}
      />
    </Space>
  );
};
